
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { 
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetClose
} from "@/components/ui/sheet";
import { CustomerInformationTab } from "./tabs/CustomerInformationTab";
import { CustomerPurchasesTab } from "./tabs/CustomerPurchasesTab";
import { CustomerCashbackTab } from "./tabs/CustomerCashbackTab";
import { CustomerReferralsTab } from "./tabs/CustomerReferralsTab";
import { CustomerActivitiesTab } from "./tabs/CustomerActivitiesTab";
import { CustomerMessagesTab } from "./tabs/CustomerMessagesTab";
import { useState } from "react";

interface CustomerDetailsSheetProps {
  customer: any;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSendMessage: (phone: string, message: string, template?: string) => void;
}

export function CustomerDetailsSheet({ 
  customer, 
  open, 
  onOpenChange, 
  onSendMessage 
}: CustomerDetailsSheetProps) {
  const [activeTab, setActiveTab] = useState("info");

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full md:max-w-[900px] overflow-y-auto">
        <SheetHeader className="mb-6">
          <div className="flex justify-between items-center">
            <div>
              <SheetTitle className="text-2xl">{customer.name}</SheetTitle>
              <SheetDescription className="flex gap-2 mt-1">
                {customer.email} · {customer.phone}
              </SheetDescription>
            </div>
          </div>
        </SheetHeader>

        <Tabs defaultValue="info" value={activeTab} onValueChange={setActiveTab}>
          <TabsList className="grid w-full grid-cols-6">
            <TabsTrigger value="info">Informações</TabsTrigger>
            <TabsTrigger value="purchases">Compras</TabsTrigger>
            <TabsTrigger value="cashback">Cashback</TabsTrigger>
            <TabsTrigger value="referrals">Indicações</TabsTrigger>
            <TabsTrigger value="activities">Atividades</TabsTrigger>
            <TabsTrigger value="messages">Mensagens</TabsTrigger>
          </TabsList>
          
          <TabsContent value="info" className="mt-6">
            <CustomerInformationTab customer={customer} />
          </TabsContent>
          
          <TabsContent value="purchases" className="mt-6">
            <CustomerPurchasesTab customerId={customer.id} />
          </TabsContent>
          
          <TabsContent value="cashback" className="mt-6">
            <CustomerCashbackTab customerId={customer.id} />
          </TabsContent>
          
          <TabsContent value="referrals" className="mt-6">
            <CustomerReferralsTab customerId={customer.id} />
          </TabsContent>
          
          <TabsContent value="activities" className="mt-6">
            <CustomerActivitiesTab customerId={customer.id} />
          </TabsContent>
          
          <TabsContent value="messages" className="mt-6">
            <CustomerMessagesTab 
              customerId={customer.id} 
              customer={customer}
              onSendMessage={onSendMessage} 
            />
          </TabsContent>
        </Tabs>
      </SheetContent>
    </Sheet>
  );
}
